import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import type { RouteLocationRaw } from 'vue-router'
import { defaultLocale } from '@/locales/config'

export function useLocaleRoute() {
  const route = useRoute()
  const router = useRouter()

  const locale = computed(() => (route.params.locale as string) || defaultLocale)

  /** Build a full path with the current locale prefix */
  function localePath(path: string): string {
    const clean = path.startsWith('/') ? path : `/${path}`
    return `/${locale.value}${clean}`
  }

  /** Build a named route with the current locale param */
  function localeRoute(name: string, params?: Record<string, string>): RouteLocationRaw {
    return { name, params: { locale: locale.value, ...params } }
  }

  /** Navigate to a locale-prefixed path */
  function navigateTo(path: string) {
    router.push(localePath(path))
  }

  /** Replace the current locale in the URL (for language switching) */
  function switchLocale(newLocale: string) {
    const currentPath = route.fullPath
    const stripped = currentPath.replace(new RegExp(`^/${locale.value}`), '')
    router.replace(`/${newLocale}${stripped || '/challenges'}`)
  }

  return { locale, localePath, localeRoute, navigateTo, switchLocale }
}
